export default "__VITE_ASSET__Bo6GlzFA__"